import { createContext } from "react";

export const SchoolContex = createContext({})